module.exports = __webpack_public_path__ + "15c248c776c6da30a622e608b0a383ef.jpg";